import type { TacticalReport } from '../api/types'

export const REPORT_NAMES: Record<TacticalReport['type'], string> = {
  MEDEVAC_9LINE: 'MEDEVAC',
  CASEVAC: 'CASEVAC',
  SALUTE: 'SALUTE',
  CONTACT: 'Contact',
  SITREP: 'SITREP',
  ACE: 'ACE',
}

/** Where a report is about, whichever of its forms carries the position. */
export function reportPosition(report: TacticalReport): [number, number] | null {
  const candidates: [number | undefined, number | undefined][] = [
    [report.nineLine?.line1LocationLatitude, report.nineLine?.line1LocationLongitude],
    [report.salute?.locationLatitude, report.salute?.locationLongitude],
    [report.contact?.ownLatitude, report.contact?.ownLongitude],
  ]
  for (const [lat, lon] of candidates) {
    if (lat != null && lon != null) return [lat, lon]
  }
  return null
}

export function isOpen(report: TacticalReport): boolean {
  return report.status === 'SUBMITTED' || report.status === 'ACKNOWLEDGED' || report.status === 'IN_PROGRESS'
}
